import { useRef, useCallback } from "react";
import { CurrencyVariableFields } from "@nxplatform/geo-data/slices/currency-variables.slice";
import { useMutationObservable } from "./mutation-observable.hook.js";
import '../assets/render-currency-variable.css';const loader = "currency-variable-loader-module_loader__T-ltN1Mf__platform-common";
const dotFirst = "currency-variable-loader-module_dotFirst__pwZ9TCD8__platform-common";
const dotSecond = "currency-variable-loader-module_dotSecond__n000vjnv__platform-common";
const dotThird = "currency-variable-loader-module_dotThird__g-96c-Lz__platform-common";
const s = {
  loader,
  dotFirst,
  dotSecond,
  dotThird
};
const CURRENCY_BLOCK_LOADER = `
<span class="${s.loader}">
  <span class="${s.dotFirst}">&bull;</span>
  <span class="${s.dotSecond}">&bull;</span>
  <span class="${s.dotThird}">&bull;</span>
</span>`;
const replaceAttributesWithSpans = (node, match, currency) => {
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node2) => {
      if (node2 instanceof Element) {
        const { attributes } = node2;
        for (let i = 0; i < attributes.length; i++) {
          const attribute = attributes[i];
          if (attribute.name === "data-currency-variable" && attribute.value === match) {
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      }
      return NodeFilter.FILTER_SKIP;
    }
  });
  const elementsToReplace = [];
  while (walker.nextNode()) {
    elementsToReplace.push(walker.currentNode);
  }
  elementsToReplace.forEach((element) => {
    const existingSpan = element.attributes.getNamedItem("data-currency-variable");
    if (existingSpan) {
      if (currency) {
        element.textContent = currency;
      }
      if (!currency) {
        element.innerHTML = CURRENCY_BLOCK_LOADER;
      }
    }
  });
};
const replaceTextNodesWithSpans = (node, match, currency) => {
  const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
  while (walker.nextNode()) {
    const textNode = walker.currentNode;
    if (textNode.parentElement.nodeName !== "SCRIPT") {
      const { textContent } = textNode;
      const replacedContent = textContent.replace(new RegExp(match, "g"), currency ? `<span data-currency-variable="${match}">${currency}</span>` : `<span data-currency-variable="${match}">${CURRENCY_BLOCK_LOADER}</span>`);
      if (replacedContent !== textContent) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = replacedContent;
        const newNodes = Array.from(tempDiv.childNodes);
        newNodes.forEach((newNode) => {
          try {
            textNode.parentNode.insertBefore(newNode, textNode);
          } catch (e) {
            console.error("insert failed");
          }
        });
        try {
          textNode.parentNode.removeChild(textNode);
        } catch (e) {
          console.error("remove failed");
        }
      }
    }
  }
};
const replaceCurrencyVariables = (node, match, currency) => {
  replaceTextNodesWithSpans(node, match, currency);
  replaceAttributesWithSpans(node, match, currency);
};
const regex = /{%([^%]+)%}/g;
const mutationOptions = { attributes: false, childList: true, subtree: true };
const useRenderCurrencyVariableHook = ({
  auth,
  currencyVariables,
  customerMainCurrency,
  customerIpData,
  baseCurrencyCode,
  isTextPage
}) => {
  const contentRef = useRef(document.body);
  const getAmountCurrency = (currencyObject) => {
    var _a;
    return ((_a = currencyObject.values.find((obj) => {
      var _a2;
      return obj.currencyCode === (customerMainCurrency || ((_a2 = customerIpData == null ? void 0 : customerIpData.internalCountry) == null ? void 0 : _a2.currencyId));
    })) == null ? void 0 : _a.amount) || currencyObject[CurrencyVariableFields.amountInBaseCurrency];
  };
  const getCodeCurrency = (currencyObject) => {
    const findCurrency = currencyObject.values.find((obj) => {
      var _a;
      return obj.currencyCode === (customerMainCurrency || ((_a = customerIpData == null ? void 0 : customerIpData.internalCountry) == null ? void 0 : _a.currencyId));
    });
    return findCurrency ? findCurrency.currencyCode : baseCurrencyCode;
  };
  const checkAndReplaceCurrencyVariables = useCallback((mutationList) => {
    mutationList == null ? void 0 : mutationList.forEach((el) => {
      var _a, _b;
      const matches = (_b = (_a = el == null ? void 0 : el.target) == null ? void 0 : _a.innerHTML) == null ? void 0 : _b.match(regex);
      if (matches) {
        matches.forEach((match) => {
          var _a2;
          try {
            const currencyObject = (_a2 = window.currencyVariables || currencyVariables) == null ? void 0 : _a2.find((variable) => variable.frontendIdentifier.toLowerCase() === match.toLowerCase());
            if (currencyObject) {
              const amountCurrency = getAmountCurrency(currencyObject);
              const codeCurrency = getCodeCurrency(currencyObject);
              const currency = `${Intl.NumberFormat(codeCurrency).format(Number(amountCurrency))} ${codeCurrency}`;
              const useCurrency = auth ? customerMainCurrency : customerIpData;
              replaceCurrencyVariables(el == null ? void 0 : el.target, match, useCurrency ? currency : null);
            }
          } catch (error) {
            console.error("[Currency Variable Error]", {
              match,
              error
            });
          }
        });
      }
    });
  }, [currencyVariables, customerMainCurrency, customerIpData, auth]);
  useMutationObservable({
    targetEl: contentRef.current,
    cb: checkAndReplaceCurrencyVariables,
    options: mutationOptions
  });
};
export {
  useRenderCurrencyVariableHook
};
